export default "__VITE_PUBLIC_ASSET__da10bffb__"